import React from 'react'
import { IProps } from './Interface'
import { useTheme, useMediaQuery, Grid, Typography, Box } from '@material-ui/core'
import useStyles, { Container, RatingSlider } from './Styles'
import { Section } from 'components/section'
import { Balloon, Corner } from 'components/balloon'
import cx from 'classnames'

const ImGoodAtPageDisplay: React.FC<IProps> = ({ expertise, becomeExpertIn, lastChildren }) => {
  const classes = useStyles({})
  const theme = useTheme()
  const downSM = useMediaQuery(theme.breakpoints.down('sm'))
  const downMD = useMediaQuery(theme.breakpoints.down('md'))
  const borderRadiusFirstContainer = downMD
    ? { bottomLeft: 0, bottomRight: 0 }
    : { topLeft: 0, topRight: 0, bottomLeft: 0, bottomRight: 0 }
  const borderRadiusSecondContainer = downMD
    ? { topLeft: 0, topRight: 0 }
    : { topLeft: 0, topRight: 0, bottomLeft: lastChildren ? 12 : 0, bottomRight: lastChildren ? 12 : 0 }

  const colors = ['#413292', '#1BA3E6', '#F26723']

  const expertiseTagMarks = [
    {
      value: 0,
      label: 'Set level of expertise'
    },
    {
      value: 1,
      label: 'Interested'
    },
    {
      value: 2,
      label: 'Pursuing'
    },
    {
      value: 3,
      label: 'Accomplished'
    },
    {
      value: 4,
      label: 'Master'
    }
  ]

  const getValue = (v: number) => expertiseTagMarks.find(({ value }) => v <= value).label

  return (
    <Grid container direction={'column'}>
      <Section borderRadius={borderRadiusFirstContainer} padding={'0 50px'} direction={'column'}>
        <Box className={classes.firstContainer}>
          {downSM && (
            <Typography>
              <label id="i-am-good-at-title" className={classes.title}>
                I am good at
              </label>
            </Typography>
          )}
          <Grid container direction={'row'}>
            {colors.map((color: string, index: number) => {
              return (
                expertise[index] && (
                  <Grid key={index} item xs={12} md={6} className={`i-good-at-knowledge-section-${index + 1}`}>
                    <Container container>
                      <Grid item md={2} className={classes.balloon} hidden={downSM}>
                        <Balloon corner={Corner.MiddleRight} bgColor={color} size={38} shadow={false} />
                      </Grid>
                      <Grid item md={10} xs={12} className={classes.gridContainer}>
                        <div className={classes.headerKnowledge}>
                          <Typography>
                            <label id="i-am-good-at-knowledge-title" className={classes.knowledgeTitle}>
                              {expertise[index]?.title}
                            </label>
                          </Typography>
                        </div>
                        <Grid item className={classes.ratingContainer}>
                          <Grid container direction="column" spacing={1} justify="center">
                            {(expertise[index]?.tags?.length ? expertise[index]?.tags : [{}]).map(
                              (item: any, key: number) => {
                                return (
                                  <Grid item key={key} className={classes.row}>
                                    <Grid
                                      container
                                      direction="row"
                                      spacing={2}
                                      justify="space-around"
                                      alignItems="center"
                                    >
                                      <Grid className={classes.gridExpertise} item xs={5}>
                                        <Typography id="i-am-good-at-expertise-level" className={classes.expertise}>
                                          {getValue(item.level || 0)}
                                        </Typography>
                                        <RatingSlider
                                          className={
                                            !item.level || item.level < 2
                                              ? classes.marksEmpty
                                              : item.level < 3
                                              ? classes.marksLevelThree
                                              : classes.marksFull
                                          }
                                          valueLabelDisplay="off"
                                          disabled={true}
                                          min={0}
                                          max={4}
                                          value={item.level || 0}
                                          id="i-am-good-at-expertise-level-value"
                                        />
                                      </Grid>
                                      <Grid item xs={7} style={{ whiteSpace: 'nowrap' }}>
                                        <Typography className={classes.paragraph}>
                                          <label
                                            id="i-am-good-at-expertise-level-title"
                                            className={classes.definedCategory}
                                            title={item.title}
                                          >
                                            {item.title ? item.title : ''}
                                          </label>
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                )
                              }
                            )}
                          </Grid>
                        </Grid>
                      </Grid>
                    </Container>
                  </Grid>
                )
              )
            })}
          </Grid>
        </Box>
      </Section>

      {becomeExpertIn.length > 0 && (
        <div className={cx(classes.becomeExpertInRootContainer, 'i-good-at-i-want-to-get-better-section')}>
          <Section borderRadius={borderRadiusSecondContainer} background={'#A7DDF6'} padding={'20px 50px 20px'}>
            <Grid container direction={'column'}>
              <Typography>
                <label className={classes.becomeExpertIn}>I want to get better at</label>
              </Typography>
              <Grid container direction="column" justify="center" className={classes.becomeExpertInContainer}>
                <Grid item md={6} xs={12}>
                  {becomeExpertIn.map((item: any, index: number) => {
                    return (
                      <div className={classes.becomeExpertInItem} key={index}>
                        <div className={classes.becomeExpertInValue}>
                          <Typography style={{ display: 'flex', flex: 1 }}>
                            <label className={classes.learning}>{item}</label>
                          </Typography>
                        </div>
                      </div>
                    )
                  })}
                </Grid>
              </Grid>
            </Grid>
          </Section>
        </div>
      )}
    </Grid>
  )
}

ImGoodAtPageDisplay.defaultProps = {
  expertise: [],
  becomeExpertIn: [],
  lastChildren: false
}

export default (props: IProps) => <ImGoodAtPageDisplay {...props} />
